module.exports = __webpack_public_path__ + "img/解决方案_能源_绿.6ff2bdbe.svg";